import type { Dispatch, MutableRefObject, SetStateAction } from 'react';

export const loadStationDetails = async ({
    stationId,
    batchId,
    stationDetailsByIdRef,
    stationDetailsLoadingByIdRef,
    setStationDetailsLoadingById,
    getChargingLocationById,
    transformStations,
    summaryStation,
    stations,
    preserveSummaryStationStatus,
    sidebarBatchIdRef,
    setStationDetailsById,
    sidebarDetailsDurationRef,
    sidebarDetailsCompletedCountRef,
}: {
    stationId: string | number;
    batchId: number;
    stationDetailsByIdRef: MutableRefObject<Record<string, any>>;
    stationDetailsLoadingByIdRef: MutableRefObject<Record<string, boolean>>;
    setStationDetailsLoadingById: Dispatch<SetStateAction<Record<string, boolean>>>;
    getChargingLocationById: (id: string | number) => Promise<any>;
    transformStations: (payload: any) => any[];
    summaryStation?: any;
    stations: any[];
    preserveSummaryStationStatus: (summaryStation: any, detailedStation: any) => any;
    sidebarBatchIdRef: MutableRefObject<number>;
    setStationDetailsById: Dispatch<SetStateAction<Record<string, any>>>;
    sidebarDetailsDurationRef: MutableRefObject<number>;
    sidebarDetailsCompletedCountRef: MutableRefObject<number>;
}) => {
    const stationIdKey = String(stationId);

    if (stationDetailsByIdRef.current[stationIdKey]) {
        return stationDetailsByIdRef.current[stationIdKey];
    }

    if (stationDetailsLoadingByIdRef.current[stationIdKey]) {
        return null;
    }

    setStationDetailsLoadingById((currentState) => ({
        ...currentState,
        [stationIdKey]: true,
    }));

    const requestStartedAt = performance.now();

    try {
        const stationDetails = await getChargingLocationById(stationId);
        const requestDuration = performance.now() - requestStartedAt;
        const transformedStation = transformStations(stationDetails)?.[0];
        const fallbackSummaryStation =
            summaryStation ??
            stations.find((point) => String(point.properties?.id) === stationIdKey);
        const detailedStation = preserveSummaryStationStatus(fallbackSummaryStation, transformedStation);

        if (batchId !== sidebarBatchIdRef.current) {
            return null;
        }

        if (detailedStation?.properties?.data) {
            setStationDetailsById((currentDetails) => ({
                ...currentDetails,
                [stationIdKey]: detailedStation,
            }));

            sidebarDetailsDurationRef.current += requestDuration;
            sidebarDetailsCompletedCountRef.current += 1;

            return detailedStation;
        }

        return null;
    } catch (error) {
        console.error('Failed to fetch charge point details:', error);
        return null;
    } finally {
        setStationDetailsLoadingById((currentState) => {
            const nextState = {...currentState};
            delete nextState[stationIdKey];
            return nextState;
        });
    }
};
